/**
 * Per-league standings history snapshots.
 *
 * Stored at leagues/{id}/history/{matchday} (doc id = matchday number as a string).
 * Written only by Cloud Functions at settlement (see functions/src/matchday/engine.ts
 * writeLeagueHistoryColumn); league members have read access (firestore.rules).
 *
 * `order` and `scores` are parallel, rank-ordered arrays (index 0 = rank 1) and only
 * include members with a complete list (hasList === true) at that matchday.
 */
import {
  collection,
  type Firestore,
  orderBy,
  type Query,
  query,
  type QueryConstraint,
  type Timestamp,
} from 'firebase/firestore';

export interface LeagueHistoryColumn {
  /** MatchDay this column belongs to (1..MATCHDAY_COUNT). */
  matchday: number;
  /** UserIds in rank order (index 0 = 1st place). */
  order: string[];
  /** Cumulative scores parallel to `order`. */
  scores: number[];
  updatedAt?: Timestamp;
}

/** All settled standings columns for a league, oldest matchday first. */
export function queryLeagueHistory(db: Firestore, leagueID: string, ...queries: QueryConstraint[]): Query {
  return query(collection(db, 'leagues', leagueID, 'history'), orderBy('matchday', 'asc'), ...queries);
}
